import { CLEAR_TAB_FILTERS, GET_USER_PREFERENCES, SAVE_TAB_FILTERS, SET_TAB_FILTERS } from './userPreferences.type';

export const getUserPreferences = () => {
    return {
        type: GET_USER_PREFERENCES,
    };
};

/** Local store update only — no request. See the type file for why it is separate. */
export const setTabFilters = (tab, filters) => {
    return {
        type: SET_TAB_FILTERS,
        payload: { tab, filters },
    };
};

export const saveTabFilters = (tab, filters) => {
    return {
        type: SAVE_TAB_FILTERS,
        payload: { tab, filters },
    };
};

export const clearTabFilters = (tab) => {
    return {
        type: CLEAR_TAB_FILTERS,
        payload: { tab },
    };
};
